(() => {
  if (window.dragScrollReady) return;
  window.dragScrollReady = true;

  const SELECTOR = '[data-drag-scroll]';

  // 位移在该阈值内仍视为点击，避免按下时的轻微抖动吞掉链接
  const CLICK_THRESHOLD = 4;

  const hasMouse = () => window.matchMedia('screen and (pointer: fine)').matches;
  const isScrollable = (area) => area.scrollWidth - area.clientWidth > 1;

  let area = null;
  let startX = 0;
  let startScrollLeft = 0;
  let dragged = false;

  const onMouseMove = (event) => {
    const dx = event.clientX - startX;

    if (!dragged && Math.abs(dx) <= CLICK_THRESHOLD) return;

    dragged = true;
    event.preventDefault();
    area.classList.add('is-dragging');
    area.scrollLeft = startScrollLeft - dx;
  };

  const onMouseUp = () => {
    const dragArea = area;
    area = null;

    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    dragArea.classList.remove('is-dragging');

    if (!dragged) return;

    const suppressClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    // 松手后紧跟的 click 属于本次拖拽；落点不在链接上时不会触发，下一帧撤掉监听
    dragArea.addEventListener('click', suppressClick, { capture: true, once: true });
    requestAnimationFrame(() => dragArea.removeEventListener('click', suppressClick, { capture: true }));
  };

  document.addEventListener('mousedown', (event) => {
    if (area || event.button !== 0 || !hasMouse()) return;

    const dragArea = event.target.closest?.(SELECTOR);
    if (!dragArea || !isScrollable(dragArea)) return;

    area = dragArea;
    startX = event.clientX;
    startScrollLeft = dragArea.scrollLeft;
    dragged = false;

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  });

  // 内容是搜索结果异步注入的，进入时才能判断当前是否真的溢出
  document.addEventListener('mouseover', (event) => {
    const dragArea = event.target.closest?.(SELECTOR);

    if (dragArea) {
      dragArea.classList.toggle('is-drag-scrollable', isScrollable(dragArea));
    }
  });
})();
